import { useMemo } from 'react';
import { useInteractionContext } from '../../context';

const useFilterUnselected = <T extends { id: string }>(items: T[]) => {
  const { isSelected } = useInteractionContext();
  return useMemo(() => items.filter(d => !isSelected(d.id)), [items, isSelected]);
};

export default useFilterUnselected;
